import {
  CheckCircle,
  Eye,
  EyeSlash,
  WarningCircle,
} from '@phosphor-icons/react'
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import PrevixLogo from '../../assets/images/PrevixLogoTextHorizontal.svg'
import { BackButton } from '../../components/BackButton'
import { Modal } from '../../components/Modal'
import { Button } from '../../components/common/Button'
import { Input } from '../../components/common/Input'
import api from '../../services/api'
import {
  ButtonContainer,
  Container,
  Content,
  InputContainer,
  Link,
  LoginFooter,
  LoginImage,
  LogoImage,
  MainContent,
} from './styles'
import { useAuth } from '../../context/authProvider'

export const Login = () => {
  const { signIn, loginRejected, setLoginRejected } = useAuth()

  const [isPasswordShowing, setIsPasswordShowing] = useState(false)
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')

  const [modalAcessAuthSuccess, setModalAcessAuthSuccess] = useState(false)
  const [modalAcessAuthError, setModalAcessAuthError] = useState(false)
  const [modalPasswordError, setModalPasswordError] = useState(false)

  const verifyLogin = () => {
    if (loginRejected) {
      setLoginRejected((prev) => !prev)
      toggleFunction(setModalAcessAuthError)
    }
  }
  // const navigate = useNavigate()
  // useEffect(() => {
  //   const token = localStorage.getItem('token')

  //   if (token) {
  //     navigate('/home')
  //   }
  // }, [navigate])

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleLogin = (e) => {
    e.preventDefault()
    signIn({ login, password })
      .then((response) => {
        verifyLogin()
      })
      .catch((error) => {
        console.log(error)
        error.response.data.statusCode === 401
          ? toggleFunction(setModalPasswordError)
          : toggleFunction(setModalAcessAuthError)
      })
  }

  return (
    <>
      <Helmet>
        <title>Previx - Login</title>
        <meta name="Previx - Login" content="Página de login previx" />
      </Helmet>
      <Container>
        <Content onSubmit={handleLogin}>
          <LogoImage src={PrevixLogo} />
          <MainContent>
            <BackButton goTo={''} />
            <InputContainer>
              <Input.Root>
                <Input.Label
                  title="Nome do usuário"
                  htmlFor="userLogin"
                  color="#150D49"
                />
                <Input.Wrapper
                  borderColor="#0079B1"
                  backgroundColor="#EDF4FC"
                  outlineColor="#006598"
                >
                  <Input.Content
                    id="userLogin"
                    type="text"
                    placeholder="Usuário"
                    onChange={(e) => setLogin(e.target.value)}
                  />
                </Input.Wrapper>
              </Input.Root>
              <Input.Root>
                <Input.Label
                  title="Senha"
                  htmlFor="passwordLogin"
                  color="#150D49"
                />
                <Input.Wrapper
                  borderColor="#0079B1"
                  backgroundColor="#EDF4FC"
                  outlineColor="#006598"
                >
                  <Input.Content
                    id="passwordLogin"
                    type={isPasswordShowing ? 'text' : 'password'}
                    placeholder="Senha"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <Input.Icon
                    onClick={() => toggleFunction(setIsPasswordShowing)}
                  >
                    {isPasswordShowing ? (
                      <Eye size={14} color="#52427B" />
                    ) : (
                      <EyeSlash size={14} color="#52427B" />
                    )}
                  </Input.Icon>
                </Input.Wrapper>
              </Input.Root>
              <Link href="/recuperar/senha">Esqueci a senha</Link>
            </InputContainer>

            <ButtonContainer>
              <Button.Root
                type="submit"
                backgroundColor="#150D49"
                onClick={handleLogin}
              >
                <Button.Content title="Entrar" />
              </Button.Root>
            </ButtonContainer>
          </MainContent>
          <LoginFooter>2023 - Powered by Ubicuacloud ©</LoginFooter>
        </Content>
        <LoginImage />
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalAcessAuthSuccess}
          setIsOpenController={() => {
            toggleFunction(setModalAcessAuthSuccess)
          }}
        >
          <Modal.Header
            onclick={() => setModalAcessAuthSuccess((prev) => !prev)}
          />
          <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
          <Modal.Content
            value="Acesso autorizado com sucesso!"
            subvalue="Aguarde enquanto o sistema carrega e 
          apresenta seus dados"
          />
          <Modal.Footer>{}</Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalAcessAuthError}
          setIsOpenController={() => {
            toggleFunction(setModalAcessAuthError)
          }}
        >
          <Modal.Header
            onclick={() => setModalAcessAuthError((prev) => !prev)}
          />
          <Modal.Icon
            icon={<WarningCircle size={48} weight="fill" fill="#BB0000" />}
          />
          <Modal.Content
            value="Acesso não autorizado!"
            subvalue="Entre em contato com os responsáveis
          para resolver."
          />
          <Modal.Footer>{}</Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalPasswordError}
          setIsOpenController={() => {
            toggleFunction(setModalPasswordError)
          }}
        >
          <Modal.Header
            onclick={() => setModalPasswordError((prev) => !prev)}
          />
          <Modal.Icon
            icon={<WarningCircle size={48} weight="fill" fill="#BB0000" />}
          />
          <Modal.Content
            value="Senha incorreta!"
            subvalue="Verifique suas senha e veja se você não digitou ela incorretamente. Caso não saiba mais qual é,
          acesse o “Esqueci a senha”"
          />
          <Modal.Footer>{}</Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={loginRejected}
          setIsOpenController={() => {
            setLoginRejected((prev) => !prev)
          }}
        >
          <Modal.Header onclick={() => setLoginRejected((prev) => !prev)} />
          <Modal.Icon
            icon={<WarningCircle size={48} weight="fill" fill="#BB0000" />}
          />
          <Modal.Content
            value="Usuário não permitido!"
            subvalue="Verifique suas senha e veja se você não digitou ela incorretamente. Caso não saiba mais qual é,
          acesse o “Esqueci a senha”"
          />
          <Modal.Footer>{}</Modal.Footer>
        </Modal.Root>
      </Container>
    </>
  )
}
